import bitrixResize from "./bitrixResize";

/**
 * Прокрутка страницы приложения.
 *
 * Внутри Битрикса скролл устроен иначе: bitrixResize тянет iframe на высоту
 * всего контента, и страницу прокручивает внешнее окно Битрикса, а не документ
 * внутри iframe. Прокручивать документ из кода там бессмысленно и опасно — в
 * лучшем случае двигать нечего, в худшем страница уезжает, а вернуть её руками
 * нельзя. Поэтому в Битриксе прокрутку выполняет bitrixResize: он догоняет
 * высоту окна и просит прокрутиться само окно Битрикса.
 */
export const scrollAppIntoView = (node, options = { behavior: "smooth", block: "start" }) => {
  if (!node) {
    return;
  }

  if (bitrixResize.scrollToNode(node, options)) {
    return;
  }

  if (typeof node.scrollIntoView === "function") {
    node.scrollIntoView(options);
  }
};

/**
 * Возврат страницы на прежнее место после перерисовки.
 *
 * Восстанавливается только ранее снятая позиция, своей прокрутки здесь не
 * появляется: когда документ не прокручивается, снятая позиция равна нулю и
 * вызов ничего не меняет.
 */
export const restoreAppScrollPosition = (scrollY) => {
  if (typeof window === "undefined" || !Number.isFinite(scrollY)) {
    return;
  }

  const restore = () => window.scrollTo({ top: scrollY, behavior: "auto" });
  restore();
  requestAnimationFrame(restore);
  setTimeout(restore, 0);
};
